@if (enabled()) {
  <section class="BrowseByCategory" [style]="styles().container">
    <div class="container">
      <div class="BrowseByCategory__heading">
        <h2 i18n="@@browseByCategory_Title" class="BrowseByCategory__heading__title">Browse Equipment</h2>
      </div>
      <div class="BrowseByCategory__content">
        @if (categories$ | async; as categories) {
          @for (item of categories.data; track item.category_id) {
            <div data-testid="category-item">
              <a [routerLink]="[SearchRoutePaths.CategoryFull.replace(':category', item.category)]" class="BrowseByCategory__content__item" [style]="styles().category">
                @if (display()) {
                  @if (item.image) {
                    <div class="BrowseByCategory__content__item__image">
                      <img width="100" height="80" [src]="'https://imageserver.rouseservices.com/ImageProcessor/get/getimage.aspx?&transparent=true&type=ItemDetailBig&guid=' + item.image" [alt]="item.category" loading="lazy"/>
                    </div>
                  } @else {
                    <div class="BrowseByCategory__content__item__image">
                      <img width="100" height="80" [src]="globalData.defaultImage()" alt="" loading="lazy"/>
                    </div>
                  }
                }
                <div class="BrowseByCategory__content__item__container">
                  <h3 class="BrowseByCategory__content__item__title">
                    {{ item.category }}
                  </h3>
                  <p class="BrowseByCategory__content__item__quantity" [style]="styles().subtext">
                    {{ quantityAvailable.replace('{quantity}', item.quantity.toString()) }}
                  </p>
                </div>

              </a>
            </div>
          }
        } @else {
          @for (item of [].constructor(+quantity()); track item) {
            <div>
              <div class="BrowseByCategory__content__item spinner" [style]="styles().category">
                <mat-spinner diameter="25"></mat-spinner>
              </div>
            </div>
          }
        }
        <a
          i18n="@@browseByCategory_ViewMoreLink"
          (click)="loadAndOpenCategoryFilters()"
          class="BrowseByCategory__content__item BrowseByCategory__content__item--view-more"
          [style]="styles().category">
          View more equipment
        </a>
      </div>
    </div>
  </section>
}